(function () {
  'use strict';

  function init(root) {
    if (root.dataset.ntCustomReady === 'true') return;
    var form = root.querySelector('[data-nt-custom-form]');
    if (!form) return;
    root.dataset.ntCustomReady = 'true';
    var brand = root.querySelector('[data-nt-vehicle-brand]');
    var model = root.querySelector('[data-nt-vehicle-model]');
    var year = root.querySelector('[data-nt-model-year]');
    var submit = root.querySelector('[data-nt-request-submit]');
    var submitLabel = submit.querySelector('span');
    var status = root.querySelector('[data-nt-request-status]');
    var validation = root.querySelector('[data-nt-request-validation]');
    var fields = root.querySelector('[data-nt-request-fields]');
    var sections = Array.from(root.querySelectorAll('[data-nt-request-section]'));
    var filesBySection = new Map();
    var urls = new Set();
    var vehicleData = window.NTVehicleOptions || window.ntVehicleOptions || {};
    var messages = JSON.parse(root.querySelector('[data-nt-custom-messages]').textContent);
    var startedAt = Date.now();
    var submissionId = crypto.randomUUID();
    var busy = false;
    var sent = false;
    var endpoint = null;
    try {
      var parsed = new URL(root.dataset.intakeUrl, location.origin);
      if (root.dataset.submissionsEnabled === 'true' && parsed.protocol === 'https:' &&
          parsed.pathname === '/api/custom-inquiries/intake' && !parsed.username && !parsed.password && !parsed.search && !parsed.hash) endpoint = parsed.href;
    } catch {}

    function showStatus(message, state) {
      status.hidden = false;
      status.dataset.state = state;
      status.textContent = message;
    }

    function option(label, value) {
      var node = document.createElement('option');
      node.textContent = label;
      node.value = value === undefined ? label : value;
      return node;
    }

    function resetSelect(select, label) {
      select.replaceChildren(option(label, ''));
      select.disabled = true;
    }

    function fillModels() {
      resetSelect(model, messages.select_model);
      resetSelect(year, messages.select_year);
      var entry = vehicleData[brand.value];
      (Array.isArray(entry) ? entry : Object.keys(entry || {})).forEach(function (name) { model.appendChild(option(name)); });
      model.disabled = model.options.length === 1;
      updateSubmit();
    }

    function fillYears() {
      resetSelect(year, messages.select_year);
      var entry = vehicleData[brand.value];
      var years = entry && !Array.isArray(entry) && Array.isArray(entry[model.value]) ? entry[model.value].slice() : [];
      if (model.value && !years.length) {
        for (var value = new Date().getFullYear() + 1; value >= 1985; value -= 1) years.push(String(value));
      }
      years.forEach(function (value) { year.appendChild(option(String(value))); });
      year.disabled = year.options.length === 1;
      updateSubmit();
    }

    function sectionHasContent(section) {
      return Boolean(section.querySelector('[data-nt-section-text]').value.trim() || filesBySection.get(section).length);
    }

    function requiredFieldsValid() {
      return Array.from(form.querySelectorAll('[required]')).every(function (field) {
        return !field.disabled && field.value.trim() && field.checkValidity();
      });
    }

    function updateSubmit() {
      sections.forEach(function (section) { section.classList.toggle('is-complete', sectionHasContent(section)); });
      var hasContent = sections.some(sectionHasContent);
      submit.disabled = !endpoint || busy || sent || !hasContent;
      if (validation) {
        validation.hidden = !endpoint || busy || sent || (hasContent && requiredFieldsValid());
        validation.textContent = hasContent ? messages.required_fields : messages.validation;
      }
      submitLabel.textContent = sent ? messages.submitted : busy ? messages.sending : messages.submit;
    }

    function renderFiles(section) {
      var target = section.querySelector('[data-nt-file-previews]');
      target.querySelectorAll('img').forEach(function (image) { URL.revokeObjectURL(image.src); urls.delete(image.src); });
      target.replaceChildren();
      filesBySection.get(section).forEach(function (file, index) {
        var item = document.createElement('div');
        var image = document.createElement('img');
        var label = document.createElement('span');
        var remove = document.createElement('button');
        item.className = 'nt-custom-request__preview';
        image.alt = file.name;
        image.src = URL.createObjectURL(file);
        urls.add(image.src);
        label.textContent = file.name;
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', messages.remove_image.replace('{name}', file.name));
        remove.addEventListener('click', function () {
          var next = filesBySection.get(section).slice();
          next.splice(index, 1);
          filesBySection.set(section, next);
          renderFiles(section);
          updateSubmit();
        });
        item.append(image, label, remove);
        target.appendChild(item);
      });
    }

    function addFiles(section, added) {
      if (busy || sent) return;
      var existing = filesBySection.get(section);
      var next = existing.slice();
      var invalid = false;
      Array.from(added).forEach(function (file) {
        if (!/^image\/(jpeg|png|webp)$/.test(file.type) || !file.size || file.size > 20 * 1024 * 1024) { invalid = true; return; }
        if (!next.some(function (old) { return old.name === file.name && old.size === file.size && old.lastModified === file.lastModified; })) next.push(file);
      });
      if (invalid) { showStatus(messages.invalid_file, 'error'); return; }
      var all = sections.flatMap(function (entry) { return entry === section ? next : filesBySection.get(entry); });
      if (all.length > 10 || all.reduce(function (sum, file) { return sum + file.size; }, 0) > 60 * 1024 * 1024) {
        showStatus(messages.upload_limit, 'error');
        return;
      }
      filesBySection.set(section, next);
      renderFiles(section);
      if (endpoint) status.hidden = true;
      updateSubmit();
    }

    sections.forEach(function (section) {
      filesBySection.set(section, []);
      var textarea = section.querySelector('[data-nt-section-text]');
      var counter = section.querySelector('[data-nt-character-count]');
      var input = section.querySelector('[data-nt-section-files]');
      var dropzone = section.querySelector('.nt-custom-request__upload');
      textarea.addEventListener('input', function () { counter.textContent = textarea.value.length; updateSubmit(); });
      input.addEventListener('change', function () { addFiles(section, input.files || []); input.value = ''; });
      dropzone.addEventListener('dragover', function (event) { event.preventDefault(); if (!busy && !sent) dropzone.classList.add('is-dragging'); });
      dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('is-dragging'); });
      dropzone.addEventListener('drop', function (event) { event.preventDefault(); dropzone.classList.remove('is-dragging'); addFiles(section, event.dataTransfer.files); });
    });

    brand.addEventListener('change', fillModels);
    model.addEventListener('change', fillYears);
    form.addEventListener('input', updateSubmit);
    form.addEventListener('change', updateSubmit);
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!endpoint || busy || sent) return;
      if (!requiredFieldsValid()) { form.reportValidity(); return; }
      if (!sections.some(sectionHasContent)) return;
      var payload = new FormData(form);
      sections.forEach(function (section) {
        var name = section.dataset.ntRequestSection + '_images';
        payload.delete(name);
        filesBySection.get(section).forEach(function (file) { payload.append(name, file, file.name); });
      });
      payload.set('started_at', String(startedAt));
      payload.set('submission_id', submissionId);
      busy = true;
      updateSubmit();
      fields.disabled = true;
      form.setAttribute('aria-busy', 'true');
      showStatus(messages.sending, 'pending');
      var controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, 90000);
      try {
        var response = await fetch(endpoint, { method: 'POST', body: payload, credentials: 'omit', redirect: 'error', signal: controller.signal });
        var result = await response.json();
        if (!response.ok || result.ok !== true || !/^WEB-[A-F0-9]{24}$/.test(result.reference || '')) throw new Error('submission-failed');
        sent = true;
        showStatus(messages.success.replace('{reference}', result.reference), 'success');
        status.focus();
      } catch {
        showStatus(messages.retry, 'error');
        fields.disabled = false;
      } finally {
        window.clearTimeout(timer);
        busy = false;
        form.setAttribute('aria-busy', 'false');
        updateSubmit();
      }
    });

    root.addEventListener('nt:custom:destroy', function () { urls.forEach(function (url) { URL.revokeObjectURL(url); }); urls.clear(); });
    fillModels();
    updateSubmit();
    if (!endpoint) showStatus(messages.unavailable, 'notice');
  }

  function initAll(scope) { scope.querySelectorAll('[data-nt-custom-request]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-nt-custom-request]').forEach(function (root) { root.dispatchEvent(new Event('nt:custom:destroy')); }); });
}());
